import { makeVar } from "@apollo/client";
import { ApplicationStep, FixedPointNumber } from "../types";

export type ApplicationProgressValue = {
	investingEntityId: string | null;
	completedSteps: ApplicationStep[];
	activeStep: ApplicationStep | null;
	unitCountDecimal: Omit<FixedPointNumber, "__typename"> | null;
};

export const applicationProgressVar = makeVar<
	Record<string, ApplicationProgressValue>
>({});

export const hydrateApplicationProgress = () => {
	if (typeof window === "undefined") {
		return;
	}

	const entries: Record<string, ApplicationProgressValue> = {};

	Object.keys(localStorage).forEach((key) => {
		if (key.startsWith("ApplicationProgress:Offer:")) {
			const offerId = key.split(":")[2];
			try {
				entries[offerId] = JSON.parse(localStorage.getItem(key) || "{}");
			} catch {
				// eslint-disable-next-line no-console
				console.error("Error parsing application progress", key);
			}
		}
	});

	applicationProgressVar(entries);
};
